/******/ (() => {
  
  //GWP start
    // document.addEventListener("DOMContentLoaded", (event) => {
    const gwp = function GWp() {
      console.log('gwp call')
      const addTocart = document.querySelector(".fp-footer");
      const PoPup = document.querySelector(".gwp-popup");
      const closePopup = document.querySelector(".fp-header svg");
      const cancelBtn = document.querySelector(".fp-footer .cn");
      if (closePopup) {
        closePopup.addEventListener("click", () => {
          document.body.classList.remove("free-popup-open");
          PoPup.classList.remove("popup-show");
        });
      }
      if (cancelBtn) {
        cancelBtn.addEventListener("click", () => {
          document.body.classList.remove("free-popup-open");
          PoPup.classList.remove("popup-show");
        });
      }
      if (addTocart) {
        let hiddenValue = null;
        const Metacount = Number(addTocart.getAttribute("data-order-count"));
    
        fetch(window.Shopify.routes.root + "cart.js")
          .then((response) => response.json())
          .then((data) => {
            const Totalprice = data.items_subtotal_price / 100;
            // Show or hide the popup based on the total price and meta count
            let hasGwpDiscount = false; // Flag to track presence of "gwp_discount"

            if(data.items.length > 0){
              if (Totalprice > window.PXUTheme.gwp_thresold && Metacount < 50) {
                data.items.forEach((dt) => {
                  if (dt.properties && typeof dt.properties === "object") {
                    if (dt.properties.hasOwnProperty("gwp_discount")) {
                      hasGwpDiscount = true; // Set flag if found
                    }
                  }
                });
      
                // console.log("hasGwpDiscount",hasGwpDiscount)
                if (!hasGwpDiscount) {
                  document.body.classList.add("free-popup-open");
                  PoPup.classList.add("popup-show");

                  if($('.cart_recomm_products #ajax-cart__content .ajax_cart_footer .cart-gwp-ajax-submit')){                    
                    $('.cart_recomm_products #ajax-cart__content .ajax_cart_footer .cart-gwp-ajax-submit').prop("disabled", false);
                  }
                  if($('.cart_recomm_products #ajax-cart__content .ajax_cart_footer .gwp-cart-product')){                    
                      $('.cart_recomm_products #ajax-cart__content .ajax_cart_footer .gwp-cart-product').removeClass("hide");
                    }
                }else{
                  if($('.cart_recomm_products #ajax-cart__content .ajax_cart_footer .cart-gwp-ajax-submit')){                    
                    $('.cart_recomm_products #ajax-cart__content .ajax_cart_footer .cart-gwp-ajax-submit ').prop("disabled", true);
                  }
                  
                  // if($('.cart_recomm_products #ajax-cart__content .ajax_cart_footer .gwp-cart-product')){                    
                  //     $('.cart_recomm_products #ajax-cart__content .ajax_cart_footer .gwp-cart-product').addClass("hide");
                  //   }
                }
              }
            }    
    
            $(document).on("click", ".gwp-ajax-submit", function(e) {
              e.preventDefault();
              
              var id = $('.gwp-popup .product-list .free-product input:checked').parent().find('.fp-content input').val()
              if(!id){
                id = $('.gwp-popup .product-list .free-product select').val();
              }
              $(this).parents('form').find('.variant-selection__variants').val(id)
              const $addToCartForm = $(this).closest("form");
              console.log("FORM DATA:",$addToCartForm.serialize())
              if (Totalprice > window.PXUTheme.gwp_thresold && Metacount < 50) {
                if (!hasGwpDiscount) {
                  window.PXUTheme.jsAjaxCart.addToCart($addToCartForm);
                }
              }
    
              return false;
            });

            // CART ATC BUTTON
            $(document).on("click", ".cart-gwp-ajax-submit", function(e) {
              e.preventDefault();
              if (Totalprice > window.PXUTheme.gwp_thresold && Metacount < 50) {
                if (!hasGwpDiscount) {

                  var id = $(this).parent().find('select').val();
                  if(!id){
                    id = $(this).parent().find('input').val();
                  }
                  $.ajax({
                  url: `/cart/add.js`,
                  method: "POST",
                  data: { id: id, quantity: 1, properties: { 'gwp_discount': true } }, // Set quantity to 0 to remove the item
                  success: function(cart) {
                    console.log('GWP removed from cart');
                    window.PXUTheme.jsAjaxCart.showDrawer();
                    window.PXUTheme.jsAjaxCart.updateView();
                    hasGwpDiscount = false;
                  }
                });
                }
              }
    
              return false;
            });

            if (Totalprice < window.PXUTheme.gwp_thresold || Metacount > 50) {
              data.items.forEach((dt) => {
                if (dt.properties && typeof dt.properties === "object") {
                  if (dt.properties.hasOwnProperty("gwp_discount")) {
                    hasGwpDiscount = true; // Set flag if found
                  }else{
                    hasGwpDiscount = false;
                  }
                }
                if (hasGwpDiscount) {
                  const variant_id = dt.variant_id
                  let formData = {
                    id: variant_id,
                    quantity: 0,
                  };

                  $.ajax({
                    url: `/cart/change.js`,
                    method: "POST",
                    data: formData, // Set quantity to 0 to remove the item
                    success: function(cart) {
                      console.log('GWP removed from cart');
                      window.PXUTheme.jsAjaxCart.showDrawer();
                      window.PXUTheme.jsAjaxCart.updateView();
                      hasGwpDiscount = false;

                      $(".ajax-cart__form").find('.gwp-congo-msg').addClass('hide')
                    }
                  });
                }
              });
            }
          })
          .catch((error) => {
            console.error("Error fetching cart:", error);
          });
      }
    };
    // });
    if(window.PXUTheme.enable_gwp_offer){
      document.addEventListener("DOMContentLoaded", (event) => {
        setTimeout( ()=>{
          gwp();  
        },3000)
      })
    }
  //GWP end

  
  // webpackBootstrap
  var __webpack_exports__ = {};
  window.PXUTheme.jsAjaxCart = {
    init: function ($section) {
      // Add settings from schema to current object
      window.PXUTheme.jsAjaxCart = $.extend(
        this,
        window.PXUTheme.getSectionData($section)
      );

      if (isScreenSizeLarge() || this.cart_action == "drawer") {
        this.initializeAjaxCart();
      } else {
        this.initializeAjaxCartOnMobile();
      }

      if (this.cart_action == "drawer") {
        this.ajaxCartDrawer = $("[data-ajax-cart-drawer]");

        $(document).on("click", "[data-ajax-cart-trigger]", function (e) {
          e.preventDefault();
          window.PXUTheme.jsAjaxCart.showDrawer();

          return false;
        });
      } else if (this.cart_action == "mini_cart") {
        this.showMiniCartOnHover();
      }

      $(document).on("click", ".ajax-submit", function (e) {
        e.preventDefault();
        const $addToCartForm = $(this).closest("form");
        window.PXUTheme.jsAjaxCart.addToCart($addToCartForm);
        if(window.PXUTheme.enable_gwp_offer){
          gwp();
        }
        return false;
      });

      $(document).on("click", "[data-ajax-cart-delete]", function (e) {
        e.preventDefault();
        const lineID = $(this).parents("[data-line-item]").data("line-item");
        const lineProductID = $(this)
          .parents("[data-product-id]")
          .data("product-id");
        const bundleProductID = $(".parentCartBundle").data("product-id");

        window.PXUTheme.jsAjaxCart.removeFromCart(lineID);

        if (window.PXUTheme.jsCart) {
          window.PXUTheme.jsCart.removeFromCart(lineID);
        }
        if(window.PXUTheme.enable_gwp_offer){
          gwp();
        }
        // if(lineProductID == bundleProductID){
        //   $(".snippet-container .parentCartBundle").remove();
        // }

        return false;
      });

      $(document).on("click", "[data-ajax-cart-close]", function (e) {
        e.preventDefault();
        window.PXUTheme.jsAjaxCart.hideDrawer();
        window.PXUTheme.jsAjaxCart.hideMiniCart();

        return false;
      });
    },
    showMiniCartOnHover: function () {
      const $el = $("[data-ajax-cart-trigger]");

      $el.hover(
        function () {
          if (
            window.PXUTheme.theme_settings.header_layout == "centered" &&
            $(".header-sticky-wrapper").hasClass("is-sticky")
          ) {
            $(".header-sticky-wrapper [data-ajax-cart-trigger]").addClass(
              "show-mini-cart"
            );
          } else {
            $el.addClass("show-mini-cart");
          }
        },
        function () {
          $el.removeClass("show-mini-cart");
        }
      );
    },
    hideMiniCart: function () {
      if (this.cart_action != "mini_cart") return false;
      const $el = $("[data-ajax-cart-close]").parents(
        "[data-ajax-cart-trigger]"
      );
      $el.removeClass("show-mini-cart");
    },
    toggleMiniCart: function () {
      const $el = $(".mobile-header [data-ajax-cart-trigger]");

      // Removes url to the cart page so user is not redirected
      $el.attr("href", "#");

      $el.off("touchstart").on("touchstart", function (e) {
        // If user clicks inside the element, do nothing
        if (e.target.closest("[data-ajax-cart-mini_cart]")) {
          return;
        }

        // Loads content into ajaxCart container for mobile header
        window.PXUTheme.jsAjaxCart.initializeAjaxCartOnMobile();

        // If user clicks outside the element, toggle the mini cart
        $el.toggleClass("show-mini-cart");
      });
    },
    showDrawer: function () {
      if (this.cart_action != "drawer") return false;
      this.ajaxCartDrawer.addClass("is-visible");
      $(".ajax-cart__overlay").addClass("is-visible");
      $('body').addClass("open-cart");
    },
    hideDrawer: function () {
      if (this.cart_action != "drawer") return false;
      this.ajaxCartDrawer.removeClass("is-visible");
      $(".ajax-cart__overlay").removeClass("is-visible");
      $('body').removeClass("open-cart");
    },
    removeFromCart: function (lineID, callback) {
      $.ajax({
        type: "POST",
        url: "/cart/change.js",
        data: "quantity=0&line=" + lineID,
        dataType: "json",
        success: function (cart) {
          window.PXUTheme.jsAjaxCart.updateView();
          if(window.PXUTheme.enable_gwp_offer){
            gwp();
          }
        },
        error: function (XMLHttpRequest, textStatus) {
          var response = eval("(" + XMLHttpRequest.responseText + ")");
          response = response.description;
        },
      });
    },
    initializeAjaxCart: function () {
      window.PXUTheme.asyncView
        .load(
          window.PXUTheme.routes.cart_url, // template name
          "ajax" // view name (suffix)
        )
        .done(({ html, options }) => {
          $("[data-ajax-cart-content]").html(html.content);

          // Converting the currencies
          if (window.PXUTheme.currencyConverter) {
            window.PXUTheme.currencyConverter.convertCurrencies();
          }

          if (options.item_count > 0) {
            $("#shopify-section-cart__recommendations").show();
          } else {
            $("#shopify-section-cart__recommendations").hide();
          }
        })
        .fail(() => {
          // some error handling
        });
    },
    initializeAjaxCartOnMobile: function () {
      this.toggleMiniCart();

      window.PXUTheme.asyncView
        .load(
          window.PXUTheme.routes.cart_url, // template name
          "ajax" // view name (suffix)
        )
        .done(({ html, options }) => {
          $(".mobile-header [data-ajax-cart-content]").html(html.content);
        })
        .fail(() => {
          // some error handling
        });
    },
    addToCart: function ($addToCartForm) {
      // console.log("$addToCartForm",$addToCartForm)
      const $addToCartBtn = $addToCartForm.find(".button--add-to-cart");

      $addToCartForm.removeClass("shopify-product-form--unselected-error");

      if ($addToCartBtn[0].hasAttribute("data-options-unselected")) {
        const cartWarning = `<p class="cart-warning__message animated bounceIn">${window.PXUTheme.translation.select_variant}</p>`;

        $(".warning").remove();

        $addToCartForm
          .addClass("shopify-product-form--unselected-error")
          .find(".cart-warning")
          .html(cartWarning);

        $addToCartBtn.removeAttr("disabled").removeClass("disabled");

        $addToCartBtn.find(".icon").removeClass("zoomOut").addClass("zoomIn");

        $addToCartBtn
          .find("span:not(.icon)")
          .text($addToCartBtn.data("label"))
          .removeClass("zoomOut")
          .addClass("zoomIn");
      } else {
        $.ajax({
          url: "/cart/add.js",
          dataType: "json",
          cache: false,
          type: "post",
          data: $addToCartForm.serialize(),
          beforeSend: function () {
            // console.log("$addToCartForm.serialize:",$addToCartForm.serialize())
            $addToCartBtn.attr("disabled", "disabled").addClass("disabled");
            $addToCartBtn.find("span").removeClass("fadeInDown").addClass("animated zoomOut");
          },
          success: function (product) {
            let $el = $("[data-ajax-cart-trigger]");

            $addToCartBtn.find(".checkmark").addClass("checkmark-active");

            function addedToCart() {
              if (!isScreenSizeLarge()) {
                $el = $(".mobile-header [data-ajax-cart-trigger]");
                window.PXUTheme.scrollToTop($el);
              } else {
                $el = $("[data-ajax-cart-trigger]");
              }

              $el.addClass("show-mini-cart");

              $addToCartBtn.find("span").removeClass("fadeInDown");
            }

            window.setTimeout(function () {
              $addToCartBtn.removeAttr("disabled").removeClass("disabled");

              $addToCartBtn.find(".checkmark").removeClass("checkmark-active");

              $addToCartBtn
                .find(".text, .icon")
                .removeClass("zoomOut")
                .addClass("fadeInDown");

              $addToCartBtn.on("webkitAnimationEnd oanimationend msAnimationEnd animationend",addedToCart);
            }, 1000);

            window.PXUTheme.jsAjaxCart.showDrawer();
            window.PXUTheme.jsAjaxCart.updateView();
            
            if(window.PXUTheme.enable_gwp_offer){
              gwp();
            }

            if (window.PXUTheme.jsCart) {
              $.ajax({
                dataType: "json",
                async: false,
                cache: false,
                dataType: "html",
                url: "/cart",
                success: function (html) {
                  const cartForm = $(html).find(".cart__form");                    
                  $(".cart__form").replaceWith(cartForm);
                },
              });
            }

            if(window.PXUTheme.enable_gwp_offer){
              if (product.properties && typeof product.properties === "object") {
                if (product.properties.hasOwnProperty("gwp_discount")) {
                  const PoPup = document.querySelector(".gwp-popup");
                  if(PoPup){
                    document.body.classList.remove("free-popup-open");
                    PoPup.classList.remove("popup-show");
                  }
                  if($('.cart_recomm_products #ajax-cart__content .ajax_cart_footer .gwp-cart-product')){                    
                    $('.cart_recomm_products #ajax-cart__content .ajax_cart_footer .gwp-cart-product').addClass("hide");
                  }
                  // const congoDiv = document.querySelector(".gwp-congo-msg")
                  // console.log("Congo Msg",congoDiv.length)
                  // if(congoDiv){
                  //   congoDiv.classList.remove('hide')
                  // }
                }
              }
            }
          },
          error: function (XMLHttpRequest) {
            let response = eval("(" + XMLHttpRequest.responseText + ")");
            response = response.description;

            const cartWarning = `<p class="cart-warning__message animated bounceIn">${response.replace(
              "All 1 ",
              "All "
            )}</p>`;

            $(".warning").remove();

            $addToCartForm.find(".cart-warning").html(cartWarning);

            $addToCartBtn.removeAttr("disabled").removeClass("disabled");

            $addToCartBtn
              .find(".icon")
              .removeClass("zoomOut")
              .addClass("zoomIn");

            $addToCartBtn
              .find("span:not(.icon)")
              .text($addToCartBtn.data("label"))
              .removeClass("zoomOut")
              .addClass("zoomIn");
          },
        });
        // const $bundleContent = $addToCartForm.next('.form_bundle_product').html();
        // console.log("Bundle Contnet =>", $bundleContent);
        // $('.snippet-container').html($bundleContent);
      }
    },
    updateView: function () {
      window.PXUTheme.asyncView.load(window.PXUTheme.routes.cart_url,"ajax").done(({ html, options }) => {
          if (options.item_count > 0) {
            const itemList = $(html.content).find(".ajax-cart__list");
            const cartDetails = $(html.content).find(".ajax-cart__details-wrapper");

            $(".ajax-cart__list").replaceWith(itemList);
            $(".ajax-cart__details-wrapper").replaceWith(cartDetails);
            $(".ajax-cart__empty-cart-message").addClass("is-hidden");
            $("#shopify-section-cart__recommendations").show();
            $(".ajax-cart__form").removeClass("is-hidden");
            $("[data-ajax-cart-trigger]").addClass("has-cart-count");
            $('[data-bind="itemCount"]').text(options.item_count);

            fetch(window.Shopify.routes.root + "cart.js")
              .then((response) => response.json())
              .then((data) => {

                // console.log("CART VIEW Data",data)
                // Show or hide the popup based on the total price and meta count
        
                let hasGwpDiscount = false; // Flag to track presence of "gwp_discount"
      
                if(data.items.length > 0){
                  data.items.forEach((dt) => {
                    if (dt.properties && typeof dt.properties === "object") {
                      if (dt.properties.hasOwnProperty("gwp_discount")) {
                        hasGwpDiscount = true; // Set flag if found
                      }
                    }
                  }); 

                  // console.log("CART VIEW hasGwpDiscount",hasGwpDiscount)
                  if(hasGwpDiscount){
                    $(".ajax-cart__form").find('.gwp-congo-msg').removeClass('hide')
                    if($('.cart_recomm_products #ajax-cart__content .ajax_cart_footer .gwp-cart-product')){                    
                      $('.cart_recomm_products #ajax-cart__content .ajax_cart_footer .gwp-cart-product').addClass("hide");
                    }
                    const PoPup = document.querySelector(".gwp-popup");
                     document.body.classList.remove("free-popup-open");
                     PoPup.classList.remove("popup-show");
                  }else{
                    $(".ajax-cart__form").find('.gwp-congo-msg').addClass('hide');
                  }

                  if (data.items.length === 1 && data.items[0].properties && data.items[0].properties.hasOwnProperty("gwp_discount")){
                    const variant_id = data.items[0].variant_id; // Get the variant ID of the single item
                    let formData = {
                      id: variant_id,
                      quantity: 0,
                    };
                
                    // Remove the item with gwp_discount
                    $.ajax({
                      url: `/cart/change.js`,
                      method: "POST",
                      data: formData, // Set quantity to 0 to remove the item
                      success: function (cart) {
                        console.log("GWP removed from cart");
                        window.PXUTheme.jsAjaxCart.showDrawer();
                        window.PXUTheme.jsAjaxCart.updateView();

                        $(".ajax-cart__form").find('.gwp-congo-msg').addClass('hide')
                      },
                    });
                  }       
                }
              })

            
            // Look for an element with class 'product-recommendations'
            const $productRecommendations = $("#shopify-section-cart__recommendations").find(".product-recommendations");

            // Selectors
            const productID = $(".ajax-cart__product").first().data("product-id");
            $productRecommendations.attr("data-product-id", productID);
            const limit = $productRecommendations.data("limit");

            const sectionID = $productRecommendations.data("section-id");

            // Build request URL
            const shopURL = $productRecommendations.data("base-url");
            const requestUrl = `${shopURL}?section_id=${sectionID}&limit=${limit}&product_id=${productID}`;

            $.ajax({
              type: "GET",
              url: requestUrl,
              success: function (data) {
                let $recommendedProductsElement = $(data)
                  .find(".product-recommendations")
                  .html();

                // Insert product list into the product recommendations container
                $productRecommendations.html($recommendedProductsElement);

                window.PXUTheme.jsProduct.relatedProducts();

                // Initialize shopify payment buttons
                if (Shopify.PaymentButton) {
                  Shopify.PaymentButton.init();
                }

                // Converting the currencies
                if (window.PXUTheme.currencyConverter) {
                  window.PXUTheme.currencyConverter.convertCurrencies();
                }
              },
            });

            // URL of the Shopify product page

            var productUrl = $(".ajax-cart__product").first().data("product-url");

            // Identifier of the <div> element to fetch content from
            var divIdentifier = ".form_bundle_product";

            // Make an AJAX GET request to the Shopify product page
            $.ajax({
              url: productUrl,
              method: "GET",
              success: function (data) {
                // Parse the fetched HTML content
                var parsedHtml = $.parseHTML(data);

                // Check if the specified <div> element exists
                var divExists = $(parsedHtml).find(divIdentifier).length > 0;

                if (divExists) {
                  // Find and extract the content from the specified <div>
                  var content = $(data).find(divIdentifier).html();

                  // Insert the content into the container
                  $(".snippet-container").html(content);
                } else {
                  $(".snippet-container .parentCartBundle").remove();
                }
              },
              error: function (error) {
                console.error("Error fetching content: " + error);
              },
            });
          } else {
            $(".ajax-cart__empty-cart-message").removeClass("is-hidden");
            $("#shopify-section-cart__recommendations").hide();
            $(".ajax-cart__form").addClass("is-hidden");
            $("[data-ajax-cart-trigger]").removeClass("has-cart-count");
            $('[data-bind="itemCount"]').text("0");
          }

          if (window.PXUTheme.currencyConverter) {
            window.PXUTheme.currencyConverter.convertCurrencies();
          }
        })
        .fail(() => {
          // some error handling
        });
    },
    unload: function ($section) {
      // Clear event listeners in theme editor
      $(".ajax-submit").off();
      $("[data-ajax-cart-delete]").off();
    },
  };

  /******/
})();
